import { Box, Stack, Typography, Card, Divider } from "@mui/material";
import Footer from "../common/components/Footer";
import { useParams } from "react-router-dom";
import {
  LoanFormHeader,
  LoanFormThankYou,
} from "./loan-app/LoanApp.component.style";

const Thankyou = () => {
  const { applicantName, phone, id } = useParams();

  return (
    <LoanFormThankYou
      sx={{ minHeight: "100vh" }}
      justifyContent="space-between"
    >
      <LoanFormHeader className="loanAppHeader">
        <div className="container" style={{ maxWidth: "1140px" }}>
          <div className="logo">
            <svg
              width="150"
              height="60"
              viewBox="0 0 122 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.9077 11.0548C4.53178 9.377 6.56401 8.39838 8.98132 8.12981C12.298 7.7614 15.1975 8.67586 17.1796 10.7152C18.3173 11.8858 19.0273 13.1937 19.4156 14.8335L19.531 15.3208H18.1942H16.8575L16.7506 14.9606C16.6025 14.4615 16.1079 13.4925 15.7587 13.0173C14.3805 11.1422 11.7436 10.1944 9.04997 10.6061C6.53431 10.9907 4.49104 12.5942 3.50628 14.9569C2.99205 16.1906 2.81444 17.0775 2.76608 18.6547C2.68512 21.2912 3.09591 22.9824 4.23282 24.6931C5.72138 26.9329 8.16415 28.0256 11.112 27.7705C13.8515 27.5335 15.855 25.9636 16.6982 23.3933L16.8442 22.9484H18.1526C18.9625 22.9484 19.3149 22.9224 19.4175 23.0698C19.508 23.1998 19.4042 23.4647 19.2486 24.0012C18.0198 28.2361 14.2377 30.6268 9.39093 30.2322C5.61896 29.9252 2.75386 28.0231 1.1706 24.7749C0.32551 23.0411 0 21.4843 0 19.177C0 16.9182 0.320589 15.3474 1.12673 13.6572C1.6592 12.5408 2.11743 11.8712 2.9077 11.0548ZM59.9378 16.3289V12.2653V8.20176H61.2106H62.4835V19.0499V29.8979H61.2106H59.9378V28.6067V27.3154L59.4206 27.8877C58.5314 28.8717 57.4525 29.5253 56.1617 29.862C55.2832 30.0912 53.4471 30.0745 52.4449 29.8283C49.5784 29.1241 47.6631 27.0783 46.9909 24.0026C46.7852 23.0614 46.7842 20.8708 46.9891 19.9449C47.349 18.3182 47.9576 17.1307 48.978 16.0639C50.0721 14.9202 51.3185 14.2364 52.8877 13.9188C53.8676 13.7205 55.7213 13.7838 56.627 14.0464C57.6943 14.356 58.3684 14.7603 59.1953 15.5868L59.9378 16.3289ZM30.5802 19.1481C31.3478 16.1809 33.3086 14.2203 36.1368 13.5922C37.007 13.3988 39.2168 13.4571 40.0831 13.6962C42.2383 14.2908 43.77 15.585 44.6732 17.5743C45.1698 18.6683 45.4897 20.4413 45.3788 21.4864L45.3227 22.0161H39.1255H32.9283L32.9835 22.7328C33.1611 25.04 34.5857 26.8329 36.6226 27.3125C37.2504 27.4604 38.6152 27.4784 39.2498 27.3472C40.5349 27.0815 41.7011 26.1891 42.2452 25.055C42.4086 24.7148 42.5422 24.3875 42.5422 24.328C42.5422 24.2448 42.8383 24.2196 43.815 24.2196C44.8199 24.2196 45.0879 24.2435 45.0879 24.3328C45.0879 24.395 45.0079 24.6906 44.9102 24.9896C44.1786 27.2286 42.4369 28.8634 40.1237 29.4825C39.1949 29.7311 37.2922 29.7534 36.3052 29.5272C34.7784 29.1774 33.7042 28.6139 32.6699 27.6204C31.4171 26.4168 30.6615 24.8648 30.4044 22.9665C30.2577 21.8834 30.3411 20.0723 30.5802 19.1481ZM100.878 20.2364C101.402 16.8033 103.686 14.3728 106.977 13.7456C107.835 13.582 109.595 13.6453 110.452 13.8705C111.679 14.193 113.015 15.0467 113.572 15.8636C113.686 16.0305 113.808 16.1674 113.843 16.1677C113.878 16.1681 113.907 15.6344 113.907 14.9818V13.7953H115.18H116.452V24.8977V36H115.18H113.907V31.5945V27.189L113.122 27.9792C112.452 28.654 112.219 28.8271 111.531 29.1641C110.321 29.7565 109.856 29.8559 108.306 29.8535C107.208 29.8519 106.872 29.8196 106.27 29.6583C104.225 29.1102 102.708 27.9095 101.736 26.0714C100.874 24.4395 100.561 22.3111 100.878 20.2364ZM79.8791 29.8132V21.7619V13.7106L80.5368 13.7112C80.8985 13.7115 81.4521 13.7361 81.7672 13.7658L82.34 13.8198V21.8165V29.8132H81.1096H79.8791ZM88.0042 15.4781C88.9776 14.5459 90.1362 13.9862 91.4757 13.8006C92.3256 13.6828 93.8089 13.7597 94.5969 13.9624C95.6995 14.2459 96.4554 14.6699 97.2489 15.4494C97.813 16.0037 98.0091 16.268 98.2875 16.8496C99.0452 18.4326 99.1416 19.3997 99.1416 25.4184V29.8132H97.8688H96.5959V25.2004C96.5959 22.3905 96.5604 20.3286 96.505 19.9247C96.2432 18.0143 95.3677 16.8049 93.8634 16.2751C93.0723 15.9965 91.6766 15.9625 90.8681 16.2021C89.1463 16.7122 88.0005 18.0437 87.5951 20.0058C87.4483 20.7163 87.4335 21.1972 87.4325 25.3002L87.4314 29.8132H86.1585H84.8857V21.8466V13.8801H86.1585H87.4314V14.9533V16.0266L88.0042 15.4781ZM22.0917 29.7284V21.8043V13.8801H23.3645H24.6374L24.6383 15.0454L24.6393 16.2107L24.865 15.9141C25.3033 15.3379 26.0446 14.7128 26.6315 14.4242C27.3979 14.0474 28.1993 13.8834 29.2833 13.8815L30.1531 13.8801V15.0997V16.3194L28.9014 16.3566C27.8726 16.3872 27.5644 16.4271 27.1701 16.5806C25.941 17.0597 25.1296 18.1881 24.7724 19.9156C24.6587 20.4652 24.6374 21.2912 24.6374 25.1483V29.7284H23.3645H22.0917ZM33.5893 18.2034C34.1722 17.0546 35.3177 16.1414 36.6124 15.7936C37.2107 15.6329 38.6271 15.6296 39.2972 15.7875C41.16 16.226 42.4844 17.6803 42.7507 19.5795L42.8072 19.9821H37.9651H33.1231V19.8036C33.1231 19.4987 33.3806 18.6146 33.5893 18.2034ZM103.642 19.609C104.253 17.5756 105.859 16.176 107.882 15.9124C108.563 15.8237 108.71 15.824 109.367 15.9154C111.669 16.2361 113.283 17.8438 113.783 20.3143C113.959 21.1817 113.914 22.9603 113.695 23.7535C113.429 24.7232 112.99 25.4832 112.299 26.1718C111.596 26.8723 110.941 27.2636 110.116 27.4759C108.164 27.9788 106.207 27.483 104.968 26.1714C104.291 25.4538 103.962 24.9049 103.678 24.0161C103.285 22.7854 103.269 20.8486 103.642 19.609ZM51.0684 17.4776C51.8386 16.7053 52.4797 16.3444 53.4463 16.1389C55.2873 15.7475 57.0478 16.229 58.2816 17.4615C58.9571 18.1362 59.3603 18.8314 59.6966 19.901C59.8714 20.4569 59.8954 20.7014 59.8954 21.9314C59.8954 23.5203 59.7994 24.0086 59.2791 25.0672C59.0523 25.5285 58.7916 25.8775 58.3279 26.3399C57.2906 27.3742 56.2635 27.7792 54.6767 27.7792C53.1101 27.7792 52.0629 27.3722 51.0566 26.3723C50.5738 25.8925 50.3699 25.6052 50.0642 24.9729C49.531 23.8705 49.3853 23.087 49.4378 21.6051C49.5059 19.6858 49.9258 18.623 51.0684 17.4776ZM70.0358 29.8132V23.1603V16.5073H71.2662H72.4966V21.9314V27.3554H74.915H77.3334V28.5843V29.8132H73.6846H70.0358ZM65.0292 29.8132V24.5163V19.2194H66.2596H67.49V24.5163V29.8132H66.2596H65.0292ZM119.107 34.7984C119.065 34.2268 119.278 33.8552 119.785 33.6198C120.369 33.3484 120.896 33.5068 121.326 34.0835C121.569 34.4083 121.555 35.0334 121.298 35.3947C120.849 36.0236 119.988 36.0964 119.443 35.5516C119.187 35.296 119.135 35.1799 119.107 34.7984Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M81.3641 0.0415393C80.2881 0.190107 79.2841 0.65505 78.4293 1.40052C78.1219 1.6685 75.1787 4.31433 71.8888 7.28018C67.5865 11.1585 65.8646 12.7619 65.7557 12.9913C65.2979 13.9547 66.0557 15.1508 67.1241 15.1512C67.3999 15.1513 81.0967 11.2474 83.6553 10.4394C85.189 9.955 86.4429 8.72247 87.0539 7.09822C87.2674 6.53073 87.2929 6.35343 87.2966 5.40499C87.302 4.06915 87.0963 3.35877 86.4133 2.35422C85.317 0.741835 83.2264 -0.215679 81.3641 0.0415393ZM79.2979 2.32032C79.7087 1.96911 80.5078 1.53663 80.9499 1.42611C81.131 1.38086 81.6878 1.35458 82.1872 1.36772C83.0354 1.39009 83.1357 1.4117 83.7146 1.69774C84.779 2.22379 85.4473 2.95807 85.8352 4.02787C86.0996 4.7569 86.0968 5.9429 85.8289 6.68489C85.4237 7.80725 84.5563 8.71188 83.4706 9.14461C83.0539 9.31073 82.8234 9.34158 82.0006 9.34158C81.1777 9.34158 80.9472 9.31073 80.5305 9.14461C79.4448 8.71188 78.5774 7.80725 78.1722 6.68489C77.9044 5.9429 77.9015 4.7569 78.1659 4.02787C78.3904 3.40852 78.8685 2.68746 79.2979 2.32032ZM66.512 14.6415C65.7931 14.1977 65.7944 13.0809 66.5142 12.6078C66.8485 12.388 67.4454 12.3869 67.8041 12.6054C68.5404 13.0537 68.5097 14.2901 67.7526 14.681C67.3974 14.8645 66.8448 14.8469 66.512 14.6415Z"
                fill="white"
              />
            </svg>

            <img
              src="../../../img/pharmacy4LessLogo.png"
              height={60}
              alt="logo"
              style={{ marginLeft: "30px" }}
            />
          </div>
          <div className="headerContent">Application Form</div>
        </div>
      </LoanFormHeader>
      <Stack sx={{ flex: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            px: 3,
            mt: { lg: 7, xs: 5 },
          }}
        >
          <Typography
            variant="h3"
            sx={{
              textAlign: "center",
              display: { sm: "block" },
              fontSize: { lg: 40, sm: 32.5, xs: 26 },
              color: "rgba(0, 0, 0, 0.85)",
              fontStyle: "normal",
            }}
          >
            Thank you {applicantName}!! your application is successfully
            submitted.
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", px: 4, py: 2 }}>
          <Box
            sx={{
              height: "1px",
              width: { lg: 700, sm: 600, xs: 500 },
              background:
                "linear-gradient(90deg, #FFFFFF 0%, rgba(0, 0, 0, 0) 49.48%, #FFFFFF 100%), linear-gradient(265.65deg, rgba(253, 92, 72, 0.9) 14.69%, rgba(255, 3, 50, 0.9) 23.35%, rgba(234, 1, 129, 0.9) 31.43%, rgba(155, 0, 120, 0.9) 44.22%, rgba(77, 0, 102, 0.9) 62.19%, rgba(0, 0, 84, 0.9) 76.51%, rgba(0, 0, 84, 0.9) 87.07%)",
            }}
          ></Box>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", px: 4, mt: 1 }}>
          <Typography
            variant="h5"
            sx={{
              textAlign: "center",
              fontWeight: "400",
              display: { sm: "block" },
              fontSize: { sm: 20, xs: 16 },
              color: "rgba(0, 0, 0, 0.85)",
              fontStyle: "normal",
            }}
          >
            You will be contacted on your registered mobile number and email
            address if our analysts will be looking for some clarification.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            px: 6,
            mt: { xs: 2, md: 1 },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
              fontWeight: "400",
              fontSize: { lg: 18, sm: 16, xs: 14 },
              color: "rgba(0, 0, 0, 0.6)",
              fontStyle: "normal",
              letterSpacing: "0.15px",
              mb: { xs: 5, md: 0 },
            }}
          >
            Thank you for trusting us for your financial needs.
          </Typography>
        </Box>
        <Stack
          flexDirection={{ xs: "column", sm: "column" }}
          sx={{
            flex: 1,
            mb: 2,
            maxWidth: "1386px",
            width: "100%",
            margin: "0 auto",
            gap: 6,
          }}
          justifyContent="space-between"
          alignItems="center"
          gap={{ xs: 10 }}
        >
          <Box
            sx={{
              flex: 2,
              textAlign: "center",
              color: "primary.main",
              position: "relative",
              maxWidth: "100%",
              width: 600,
              minHeight: "190px",
              paddingTop: "80px",
              paddingBottom: "80px",
              marginTop: "50px",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                borderRadius: "50%",
                top: 0,
                left: 40,
                zIndex: -1,
                width: 350,
                height: 350,
                background: "rgba(255, 68, 135, 0.04)",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                borderRadius: "50%",
                top: 0,
                right: 40,
                zIndex: -2,
                width: 320,
                height: 320,
                background: "rgba(133, 133, 218, 0.04)",
              }}
            />
            <Card sx={{ p: 2, borderRadius: 4 }}>
              <Stack
                alignItems="start"
                divider={<Divider orientation="horizontal" flexItem />}
                spacing={2}
              >
                <Stack direction="row">
                  <Typography
                    sx={{
                      fontSize: { xs: 16, sm: 18 },
                      fontWeight: 600,
                      mr: 1,
                      color: "#000000",
                    }}
                  >
                    Application Number :
                  </Typography>
                  <Typography
                    sx={{ fontSize: { xs: 16, sm: 18 }, color: "#000000" }}
                  >
                    {id && id.length > 0 && id !== "null" && id !== "undefined"
                      ? id
                      : "XXXXXXXXXXXX"}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography
                    sx={{
                      fontSize: { xs: 16, sm: 18 },
                      fontWeight: 600,
                      mr: 1,
                      color: "#000000",
                    }}
                  >
                    Applicant Name :
                  </Typography>
                  <Typography
                    sx={{ fontSize: { xs: 16, sm: 18 }, color: "#000000" }}
                  >
                    {applicantName && applicantName.length > 0
                      ? applicantName
                      : "N/A"}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography
                    sx={{
                      fontSize: { xs: 16, sm: 18 },
                      fontWeight: 600,
                      mr: 1,
                      color: "#000000",
                    }}
                  >
                    Applicant Phone :
                  </Typography>
                  <Typography
                    sx={{ fontSize: { xs: 16, sm: 18 }, color: "#000000" }}
                  >
                    {phone && phone.length > 0 ? phone : "N/A"}
                  </Typography>
                </Stack>
              </Stack>
            </Card>
          </Box>
          <Box
            sx={{
              flex: 1.7,
              px: "15px",
              pb: 5,
              maxWidth: 650,
              margin: "auto",
              width: "100%",
            }}
          >
            {/* <Stack gap={1.75}>
              You can reach us by emailing at loans@credilinq.ai and use above
              information as reference
            </Stack> */}
          </Box>
        </Stack>
      </Stack>
    </LoanFormThankYou>
  );
};

export default Thankyou;
